module.exports = __webpack_public_path__ + "img/smart_tales.e3218e5e.png";